import { graphql } from "../gql";

export const deleteFileAnnotationMutationDoc = graphql(`
  mutation deleteFileAnnotation($id: ID!) {
    deleteFileAnnotation(id: $id)
  }
`);
